<div class="user-info d-flex align-items-center">
    <i [class]="userIconClass + ' user-icon'"></i>
    <div class="user-details">
      <div class="user-name">{{ userName }}</div>
      <div *ngIf="userEmail" class="user-role">{{ userEmail }}</div>
      <div *ngIf="userRole" class="user-role">{{ userRole }}</div>
      <div *ngIf="userRegion" class="user-role">{{ userRegion }}</div>
    </div>
  </div>
